import { Notifier } from '@airbrake/browser';

window.Airbrake = { Notifier };

if (['staging', 'production'].includes(window.environment)) {
  window.airbrake = new Notifier({
    projectId: 160391,
    projectKey: '9c682fcec358c87a09f9528a51face02',
    environment: window.environment,
  });

  window.airbrake.addFilter(function (notice) {
    notice.context.environment = window.environment;
    return notice;
  });
}
